import { Actions } from './Constants'

export const SetRelayValueAction = (topic: string, value: any) => ({ type: Actions.Relay.Update, subject: topic, data: value })
